import { ColorPickerProps, ColorPicker as BaseColorPicker } from '@/components/molecules/ColorPicker';
import { withForm } from '@/core/form/withForm';

export const ColorPicker = withForm<ColorPickerProps>(BaseColorPicker);
